import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['content']
  static classes = ['error']

  show() {
    this.contentTarget.classList.add(this.errorClass)
  }

  hide() {
    this.contentTarget.classList.remove(this.errorClass)
  }
}
